import Icon from '@ant-design/icons';

const ChatSendIconSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5532 7.79549L1.48284 1.24236C1.42971 1.2158 1.36878 1.20955 1.31096 1.22361C1.17815 1.25642 1.09534 1.3908 1.12815 1.52517L2.47503 7.0283C2.49534 7.11111 2.55628 7.1783 2.63753 7.20486L4.94534 7.99705L2.63909 8.78924C2.55784 8.81736 2.4969 8.88299 2.47815 8.9658L1.12815 14.4767C1.11409 14.5345 1.12034 14.5955 1.1469 14.647C1.20784 14.7705 1.35784 14.8205 1.48284 14.7595L14.5532 8.24392C14.6016 8.22048 14.6407 8.17986 14.6657 8.13299C14.7266 8.00799 14.6766 7.85799 14.5532 7.79549ZM2.66878 12.9111L3.45471 9.69861L8.06721 8.1158C8.10315 8.1033 8.13284 8.07517 8.14534 8.03767C8.16721 7.97205 8.13284 7.90174 8.06721 7.8783L3.45471 6.29705L2.6719 3.09705L12.4844 8.01736L2.66878 12.9111Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ChatSendIcon = (props: any) => <Icon component={ChatSendIconSvg} {...props} />;
